import { render, staticRenderFns } from "./PageLoadSpinner.vue?vue&type=template&id=c29c1412&scoped=true&"
import script from "./PageLoadSpinner.vue?vue&type=script&lang=js&"
export * from "./PageLoadSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c1412",
  null
  
)

/* custom blocks */
import block0 from "./PageLoadSpinner.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c29c1412')) {
      api.createRecord('c29c1412', component.options)
    } else {
      api.reload('c29c1412', component.options)
    }
    module.hot.accept("./PageLoadSpinner.vue?vue&type=template&id=c29c1412&scoped=true&", function () {
      api.rerender('c29c1412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/PageLoadSpinner.vue"
export default component.exports